import { getUserRole } from '@/lib/auth/token';
import { createLogger } from '@/lib/logger';
import { Navigate } from 'react-router-dom';

const log = createLogger('AdminRoute');

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const userRole = getUserRole();

  if (userRole !== 'ADMIN') {
    log.warn('Non-admin user attempted to access admin route');
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
